import {
  SendTracking,
  TrackingEventBuilder,
  TrackingPayload,
} from '../analytics/common';

import { createContext, useContext } from 'react';

const trackingContext = createContext<SendTracking>(() => {});

export const TrackingContextProvider = trackingContext.Provider;

export function useTracking(): SendTracking {
  return useContext(trackingContext);
}

type AnyFunction = (...args: any) => any;

export function useTrackedHandler<
  N extends string,
  P extends TrackingPayload,
  F extends AnyFunction,
>(
  event: TrackingEventBuilder<N, P>,
  handler: F,
  transform: (...args: Parameters<F>) => NoInfer<P>,
): F;
export function useTrackedHandler<N extends string, F extends AnyFunction>(
  event: TrackingEventBuilder<N, undefined>,
  handler: F,
): F;
export function useTrackedHandler<
  N extends string,
  P extends TrackingPayload | undefined,
  F extends AnyFunction,
>(
  event: TrackingEventBuilder<N, P | undefined>,
  handler: F,
  transform?: (...args: Parameters<F>) => NoInfer<P>,
): F {
  const track = useTracking();

  const decoratedHandler = (...params: Parameters<F>): ReturnType<F> => {
    let payload;
    if (transform !== undefined) {
      payload = transform(...params);
    }
    track(event, payload);
    return handler(...params);
  };

  return decoratedHandler as F;
}
